import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { TokenService } from '@foxera/shared/services/token.service';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  __: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  if (authData.authenticated) {
    const tokenService = inject(TokenService);

    // Store user info and token if available
    const token = authData.keycloak.token;
    if (token) {
      // This will store both the decoded user info and the encoded token
      tokenService.storeUserInfoFromToken(token);
    }

    return true;
  }
  
  // User is not authenticated, redirect to login
  await authData.keycloak.login();
  return false;
};

export const canActivateAuth = createAuthGuard<CanActivateFn>(isAccessAllowed);
